"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=shift.dto.js.map